import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";
import { ShareTransferConsent, ShareTransferConsentForm } from "./shareTransferConsentDomain";

export function initNewForm(
  _dispatch: DbotEventDispatcher,
  context: DecisionContext<ShareTransferConsent>,
  data?: ShareTransferConsent,
): ShareTransferConsentForm {
  return new ShareTransferConsentForm(context, data);
}

export function initForm(form: ShareTransferConsentForm) {
  return form.init();
}

export function handleEvent() {}

export function isValid(form: ShareTransferConsentForm): boolean {
  return form.isValid;
}

export function validate(form: ShareTransferConsentForm): boolean {
  return form.validate();
}

export function applyForm(form: ShareTransferConsentForm): ShareTransferConsent {
  return form.toData();
}

export const shareTransferConsentHandler: DecisionTypeHandler<
  DecisionType.shareTransferConsent,
  ShareTransferConsent,
  ShareTransferConsentForm
> = {
  type: DecisionType.shareTransferConsent,
  initNewForm,
  initForm,
  handleEvent,
  isValid,
  validate,
  applyForm,
};
